<template>
  <section class="services-section py-5">
    <div class="overlay"></div>
    <div class="container position-relative text-center text-white">
      <h2 class="display-5 fw-bold mb-5 gradient-text animate-fade-down">
        💎 Nuestros Servicios
      </h2>

      <div class="row g-4 justify-content-center">
        <div
          v-for="(service, index) in services"
          :key="index"
          class="col-md-4 col-lg-4 service-wrapper"
        >
          <div
            class="card service-card animate-fade-up"
            :style="{ animationDelay: (index * 0.15) + 's' }"
          >
            <div class="card-body text-center">
              <i :class="service.icon" class="service-icon mb-3"></i>
              <h5 class="card-title fw-bold">{{ service.name }}</h5>
              <p class="card-text clamp-text">{{ service.description }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
const services = [
  { 
    name: 'Clases Funcionales', 
    description: 'Entrenamientos en grupo diseñados para mejorar movilidad, fuerza y resistencia mediante ejercicios dinámicos que simulan movimientos cotidianos. Adaptadas a todos los niveles de condición física.', 
    icon: 'bi bi-people-fill' 
  },
  { 
    name: 'Sala de Musculación', 
    description: 'Espacio equipado con máquinas y herramientas especializadas para desarrollar fuerza y masa muscular. Posibilidad de entrenamiento individual o con apoyo de instructores según tus objetivos.', 
    icon: 'bi bi-building-fill' 
  },
  { 
    name: 'Clases de Strong', 
    description: 'Disciplina grupal de alta intensidad con música motivadora que combina fuerza y resistencia cardiovascular, diseñada para lograr resultados visibles en menor tiempo.', 
    icon: 'bi bi-lightning-fill' 
  },
  { 
    name: 'Entrenamiento Personal', 
    description: 'Rutinas personalizadas según tus objetivos, combinando fuerza, resistencia y flexibilidad. Incluye seguimiento individual para optimizar resultados.', 
    icon: 'bi bi-person-fill' 
  },
  { 
    name: 'Asesoría Nutricional', 
    description: 'Planes alimenticios adaptados a tus metas y necesidades, con seguimiento profesional y recomendaciones prácticas para un estilo de vida saludable.', 
    icon: 'bi bi-egg-fried' 
  },
  { 
    name: 'Cardio', 
    description: 'Máquinas de cardio modernas y programas variados para mejorar resistencia cardiovascular y quemar calorías de manera efectiva.', 
    icon: 'bi bi-heart-pulse-fill' 
  },
  { 
    name: 'Seguimiento Físico - Taller', 
    description: 'Sesiones educativas donde se enseñan conceptos de entrenamiento, nutrición y hábitos saludables para optimizar tu progreso físico.', 
    icon: 'bi bi-journal-text' 
  },
  { 
    name: 'Seguimiento Físico - Peso', 
    description: 'Registro y control del peso corporal para monitorear avances, ajustar programas de entrenamiento y garantizar que tus objetivos se cumplan de manera efectiva.', 
    icon: 'bi bi-clipboard-check' 
  },
  { 
    name: 'Clases de Spinning', 
    description: 'Sala exclusiva para bicicletas con clases de spinning grupales, diseñadas para todos los niveles. Ideal para quienes buscan mejorar resistencia cardiovascular y divertirse en un entorno motivador.', 
    icon: 'bi bi-bicycle' 
  }
]
</script>

<style scoped>
.services-section {
  position: relative;
  min-height: 100vh;
  background: url('@/assets/images/carruzel/gym3.webp') center/cover no-repeat;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 5rem 1rem;
}

.overlay {
  position: absolute;
  top: 0; left: 0; right: 0; bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 0;
}

.container.position-relative {
  z-index: 1;
  font-family: 'Open Sans', sans-serif;
}

h2.gradient-text {
  background: linear-gradient(90deg, #F97316, #FBBF24, #F97316);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  animation: gradientMove 3s infinite linear;
}

.service-wrapper {
  perspective: 1000px;
}

.service-card {
  background-color: rgba(255, 255, 255, 0.95);
  border-radius: 15px;
  padding: 2rem 1rem;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);
  transition: transform 0.5s ease, box-shadow 0.5s ease;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 360px;
}

.service-card:hover {
  transform: translateY(-10px) rotateX(3deg) rotateY(3deg) scale(1.05);
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.25);
}

.service-icon {
  font-size: 3rem;
  color: #F97316;
  transition: transform 0.4s ease, color 0.4s ease;
}
.service-card:hover .service-icon {
  transform: rotate(15deg) scale(1.4);
  color: #FBBF24;
}

/* Clamp para texto uniforme */
.clamp-text {
  display: -webkit-box;
  -webkit-line-clamp: 5;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Animaciones */
.animate-fade-up {
  opacity: 0;
  transform: translateY(30px);
  animation: fadeUp 0.8s forwards;
  animation-fill-mode: both;
}
.animate-fade-down {
  opacity: 0;
  transform: translateY(-20px);
  animation: fadeDown 0.8s forwards;
}

@keyframes fadeUp { to { opacity: 1; transform: translateY(0); } }
@keyframes fadeDown { to { opacity: 1; transform: translateY(0); } }

@keyframes gradientMove {
  0% { background-position: 0% }
  100% { background-position: 200% }
}

/* Responsive */
@media (min-width: 992px) {
  .col-lg-4 { flex: 0 0 33.3333%; max-width: 33.3333%; }
}
@media (max-width: 991px) {
  .col-md-4 { flex: 0 0 50%; max-width: 50%; }
}
@media (max-width: 768px) {
  .col-md-4, .col-lg-4 { flex: 0 0 100%; max-width: 100%; }
  .service-card { min-height: 300px; }
}
</style>
